import colors from "./colors";
import components from "./components";

const themes = {
  components,
  colors,
};

export default themes;
